import { createAxiosInstance } from "./createAxiosInstance";
import { ROLES } from "../utils/userRole";

// Create customer axios instance with refresh token handling and telemetry
const axiosInstance = createAxiosInstance({
  baseURL: process.env.REACT_APP_API_URL,
  tokenKey: "authToken",
  userType: "customer",
  endpointPrefix: "",
  role: ROLES.CUSTOMER,
});

export default axiosInstance;
